import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { InputText } from 'ui/inputs';
import { spacing, fonts } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledMeta = styled.div`
  align-items: stretch;
  display: flex;
  font-family: ${fonts.sansSerif};
  margin-bottom: ${spacing.double};
  justify-content: flex-end;

  @media all and (max-width: 1124px) {
    /* grid-template-columns: 1fr;
    row-gap: ${spacing.base}; */
  }
`;

export const MetaSection = styled.div`
  flex: 0 0 auto;
  > * + * {
    margin-left: ${spacing.half};
  }
`;

export const LeftMeta = styled(MetaSection)``;

export const RightMeta = styled(MetaSection)`
  align-items: center;
  display: flex;
  justify-content: flex-end;

  > * {
    flex: 0 0 auto;
    margin-left: ${spacing.half};
  }

  [data-test='input-wrapper'] {
    height: ${pxToRem(40)};
  }
`;

export const WideInputText = styled(InputText)`
  width: ${pxToRem(304)};
`;

export const StyledButtonLabel = styled.span`
  display: inline-block;
  margin-left: ${spacing.half};
`;

export const StyledLink = styled(Link)`
  :hover {
    text-decoration: none;
  }
`;
